<template>
  <div class="columns is-multiline" v-if="scoreGroup">
    <div class="column is-12" v-for="(score, index) in scoreGroup.scores" :key="index">
      <article class="message is-light">
        <div class="message-header ">
          <div class="title is-size-5 has-text-centered" style="width: 100%;">
            {{ score.answerSet.process.name }} Puan Tablosu
          </div>
        </div>
        <div class="message-body">
          <div class="columns is-multiline">
            <div class="column is-6">
              <div class="is-paddingless">
                <div class="b-portlet">
                  <div class="b-portlet-header">
                    <div class="subtitle is-5 has-text-primary has-text-centered">
                      Denetim Puanı
                    </div>
                  </div>
                  <div class="b-portlet-body">
                    <DonutChartForPoint
                      :data="score.finalScore"
                      :name="`scorePoint${index}`"
                      :color="getChartColor(score.finalScore)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="is-paddingless">
                <div class="b-portlet">
                  <div class="b-portlet-header">
                    <div class="subtitle is-5 has-text-primary has-text-centered">
                      Başarı Değerlendirmesi
                    </div>
                  </div>
                  <div class="b-portlet-body">
                    <DonutChartForPoint
                      :name="`scoreComment${index}`"
                      :data="score.finalScore"
                      :label="score.scoreComment"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
    <div class="column is-12">
      <article class="message is-light">
        <div class="message-header">
          <div class="title is-size-5 has-text-centered">Ağırlıklı İç Denetim Puan Tablosu</div>
        </div>
        <div class="message-body">
          <div class="columns is-multiline">
            <div class="column is-6">
              <div class="is-paddingless">
                <div class="b-portlet">
                  <div class="b-portlet-header">
                    <div class="subtitle is-5 has-text-primary has-text-centered">
                      Denetim Puanı
                    </div>
                  </div>
                  <div class="b-portlet-body">
                    <DonutChartForPoint
                      :data="scoreGroup.finalScore"
                      name="scoreGroupPoint"
                      :color="getChartColor(scoreGroup.finalScore)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="is-paddingless">
                <div class="b-portlet">
                  <div class="b-portlet-header">
                    <div class="subtitle is-5 has-text-primary has-text-centered">
                      Başarı Değerlendirmesi
                    </div>
                  </div>
                  <div class="b-portlet-body">
                    <DonutChartForPoint
                      name="scoreGroupComment"
                      :data="scoreGroup.finalScore"
                      :label="scoreGroup.scoreComment"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import DonutChartForPoint from '@/components/DonutChartForPoint.vue'

export default {
  components: {
    DonutChartForPoint
  },
  props: ['scoreGroup'],
  methods: {
    getChartColor (score) {
      if (score >= 3.5) {
        return '#23d160'
      } else if (score >= 3.0) {
        return '#209cee'
      } else if (score >= 2.0) {
        return '#909193'
      } else if (score >= 1.0) {
        return '#ff9f1a'
      } else {
        return '#ff3860'
      }
    }
  }
}
</script>
